import React, { forwardRef } from "react";
import "./WelcomeSection.css";

const WelcomeSection = forwardRef((props, ref) => {
  return (
    <section ref={ref} className="welcome-section">
      <div className="welcome-content">
        {/* Left: Image */}
        <div className="welcome-image">
          <img src="/game-cart.png" alt="Derplandia Game" />
        </div>

        {/* Right: Text */}
        <div className="welcome-text">
          <h2>Welcome to Derplandia</h2>
          <p>
            Participate in the Derp Quest Idle Game to farm essential materials. 
            Craft and equip powerful items to your heroes to maximize their potential. 
            Team up with other players to join both Official or community-created campaigns. 
            Forge alliances, conquer dungeons, and write your own story in the Derpeverse.
          </p>
        </div>
      </div>
    </section>
  );
});

export default WelcomeSection;
